export default {
  shopify: process.env.VUE_APP_SP_CLIENT_HOST,
  bigcommerce: process.env.VUE_APP_BC_CLIENT_HOST
}
